module.exports = __webpack_public_path__ + "img/countdown-area-bg.b2407f42.webp";